// extracted by mini-css-extract-plugin
export var cardIcon = "_11-5";
export var cardIconUnframed = "_11-9";
export var checkboxCard = "_11-0";
export var checkboxCardSelected = "_11-4";
export var disabled = "_11-2";
export var interactive = "_11-1";
export var outerBorder = "_11-3";
export var spacerMedium = "_11-8";
export var spacerSmall = "_11-7";
export var spacerXsmall = "_11-6";